/**
 * the persistent message class.
 */
export class PersistentMessage {

    public message: string;
    public type: string;
}


// WEBPACK FOOTER //
// ./src/models/persistentMessage.ts